export const styles = theme => ({
  card: {
    maxWidth: "480px",
    margin: "0 auto"
  },
  amount_row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    padding: "10px 0",
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
    "&:last-child": {
      borderBottom: "none"
    }
  },
  amount_currency: {
    fontSize: "13px",
    color: "rgba(0, 0, 0, 0.54)"
  },
  amount_value: {
    fontSize: "22px",
    fontWeight: "500"
  },
  note: {
    fontSize: "12px",
    color: "rgba(0, 0, 0, 0.54)",
    lineHeight: "1.6",
    marginBottom: 0
  },
  approve_button: {
    backgroundColor: "#FFCA28",
    color: "#3D4051",
    "&:hover": {
      backgroundColor: "#FFB300"
    }
  },
  reject_button: {
    backgroundColor: "#FFCA28",
    color: "#3D4051",
    "&:hover": {
      backgroundColor: "#FFB300"
    }
  },
  result_icon: {
    fontSize: "72px"
  }
});
